import React, { useEffect, useState } from "react";
import Shell from "../components/Shell";
import BadgeIcon from "../components/BadgeIcon";
import LevelCard from "../components/LevelCard";
import QuestList from "../components/QuestList";
import { api } from "../lib/api";
import { Trophy } from "@phosphor-icons/react";

export default function Achievements() {
  const [progress, setProgress] = useState(null);
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/me/progress"), api.get("/me/badges")])
      .then(([p, b]) => { setProgress(p.data); setBadges(b.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const earnedCount = badges.filter((b) => b.earned).length;

  return (
    <Shell title="Başarıların">
      <div className="flex items-center gap-2 mb-4">
        <Trophy size={26} weight="duotone" color="#CA8A04" />
        <h1 className="font-outfit font-extrabold text-2xl text-brand-ink">Başarıların</h1>
      </div>

      {loading && <div className="text-center py-8 font-nunito text-brand-ink2">Yükleniyor...</div>}

      {progress && <LevelCard progress={progress} />}
      {progress && <QuestList quests={progress.active_quests} />}

      <section>
        <div className="flex items-center justify-between mb-3">
          <div className="text-xs uppercase tracking-widest font-nunito font-extrabold text-brand-ink">Rozetler</div>
          <span className="text-xs font-nunito text-brand-ink2" data-testid="badges-earned-count">
            {earnedCount} / {badges.length}
          </span>
        </div>
        <div className="grid grid-cols-3 gap-2" data-testid="badges-grid">
          {badges.map((b) => <BadgeIcon key={b.key} badge={b} />)}
        </div>
      </section>
    </Shell>
  );
}
